import { connect } from 'react-redux'
import StatusConnected from './status-connected'
import { disconnectFromWonde } from '../../../../../../../stores/school-data/school-data.actions'
import { getSchoolData } from '../../../../../../../stores/school-data/school-data.selectors'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = state => {
  const school = getSchoolData(state)
  return {
    id: school.id,
    statusColor: school.wonde.color
  }
}

const mapDispatchToProps = dispatch => ({
  onDisconnect: schoolId =>
    dispatch(disconnectFromWonde(schoolId)).catch(errorHandler)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StatusConnected)
